import type { VideosDefinition } from 'types/videos'

export const M01_VIDEOS = {
  fitnessLevelSquats: {
    gymVisualsSquat: {
      src: '/videos/m01/light/fitness-level/squat-gym-visual.webm',
    },
  },
  fitnessLevelPushups: {
    gymVisualsPushup: {
      src: '/videos/m01/light/fitness-level/pushup-gym-visual.webm',
    },
  },
  fitnessLevelPlank: {
    gymVisualsPlank: {
      src: '/videos/m01/light/fitness-level/plank-gym-visual.webm',
    },
  },
} as const satisfies VideosDefinition
